import type { TFunction } from "i18next";

import { ApiError } from "@/lib/api";
import { formatBytes } from "@/lib/format";

/** User-facing text for an upload or job error returned by the imports API. */
export function importErrorText(error: unknown, t: TFunction): string {
  if (error instanceof ApiError && error.code) {
    const { code, detail } = error;
    const key = `imports.errors.${code}`;
    const text = t(key, {
      free: typeof detail.free === "number" ? formatBytes(detail.free) : "",
      needed: typeof detail.needed === "number" ? formatBytes(detail.needed) : "",
    });
    if (text !== key) return text;
  }
  if (error instanceof TypeError) return t("imports.errors.network");
  return t("common.errorGeneric");
}
